module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "map-year-nav-btn",
    class: _vm.textAlign
  }, [(_vm.isDisabled) ? _c('span', {
    staticClass: "year-nav-disabled",
    domProps: {
      "innerHTML": _vm._s(_vm.buttonText)
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.isDisabled) ? _c('a', {
    attrs: {
      "tabindex": "0",
      "role": "button"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.buttonText)
    },
    on: {
      "click": _vm.navigateYears,
      "keyup": [function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.navigateYears($event)
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "space", 32)) { return null; }
        _vm.navigateYears($event)
      }]
    }
  }) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5bfdd222","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/map-controls/MapControlsYearNavigationButton.vue
// module id = 544
// module chunks = 1